import React from "react";
import LinkPreview from "./LinkPreview";

const MessageParser = ({ text }) => {
  if (!text) return null;

  // 🔍 Regex améliorée : capture les URLs avec ou sans protocole (http, https, www)
  //const urlRegex = /\b((https?:\/\/)?[a-zA-Z0-9.-]+\.[a-z]{2,}(\/[^\s]*)?)/gi;
const urlRegex = /\b((https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-z]{2,}([/?#][^\s]*)?)/gi;



  const parts = [];
  let lastIndex = 0;

  for (const match of text.matchAll(urlRegex)) {
    const url = match[0];
    const index = match.index;

    // Ajoute le texte normal avant le lien
    if (index > lastIndex) {
      parts.push(<span key={lastIndex}>{text.substring(lastIndex, index)}</span>);
    }

    // 🧠 Si l’URL ne contient pas de protocole, on ajoute https://
    const finalUrl = url.startsWith("http") ? url : `https://${url}`;

    // Ajoute la preview du lien
    parts.push(<LinkPreview key={`${finalUrl}-${index}`} url={finalUrl} />);

    lastIndex = index + url.length;
  }

  // Texte après le dernier lien
  if (lastIndex < text.length) {
    parts.push(<span key={lastIndex}>{text.substring(lastIndex)}</span>);
  }

  return <>{parts}</>;
};

export default MessageParser;
